import React from 'react'
import { Grid, Stack ,styled} from '@mui/material'
import { SubTitle } from '../components/common/subTitle'
import { ErrorMessageCard } from '../components/common/errorMessageCard'
import { BottomButtonGroup } from '../components/common/bottomButtonGroup'
import { ButtonOutlinedWarningL } from '../components/common/buttons/buttonOutlinedWarningL'
import { BackButton } from '../components/common/buttons/backButton'
import { Form } from '../components/common/inputs/form'
import { TelTextBox } from '../components/common/inputs/telTextBox'
import { TextBox } from '../components/common/inputs/textBox'
import { translate } from '../../i18n'
import { GetCategoryMstDto } from '../../dataAccess/webApi/dto/categoryMstDto'
import { useAction } from '../../containers/memberModifyChildAddress/memberModifyChildAddressService'
import { ButtonOutlinedS } from '../components/common/buttons/buttonOutlinedS'
import { FlexboxRowTop, Separator } from '../components/common/flexboxes'
import { CheckBox } from '../components/common/inputs/checkBox'

export const MemberModifyChildAddress = () => {
  const {
    CATEGORY_KEYS,
    formMethods,
    categoryMst,
    onSubmit,
    childrenResultCode,
    sameAddressFlag,
    autoCompleteAddress,
    noInputError
  } = useAction()

  const categories = categoryMst?.filter((mst) => CATEGORY_KEYS.includes(mst.category))

  return (
    <Form formMethods={formMethods} onSubmit={onSubmit}>
      <Stack spacing={2}>
        <Grid container>
          <Grid item md={3}></Grid>
          <Grid item xs={12} md={6}>
            <Stack spacing={2}>
              {!!categories?.length ?
                (<>
                  <SubTitle title={"お子さまの住所と電話番号"} />
                  {categories && 
                    categories.map((obj) => {
                      return (
                        <InputForm categoryMst={obj} sameAddressFlag={sameAddressFlag} autoCompleteAddress={autoCompleteAddress} key={obj.category}/>
                      )
                    })
                  }
                </>)
                :
                (<>
                  {translate('memberModifyChildAddress.error.noCategoryMst')}
                </>)
              }
            </Stack>
          </Grid>
        </Grid>
        {
          !!childrenResultCode && (
            <ErrorMessageCard
              messages={[translate(`memberModifyChildAddress.error.childrenResultCode${childrenResultCode}`)]}
            />
          )
        }
        {
          !!noInputError && (
            <ErrorMessageCard
              messages={[noInputError]}
            />
          )
        }
        <BottomButtonGroup>
          <ButtonOutlinedWarningL fullWidth type="submit">
            {translate('memberModifyChildAddress.button.decision')}
          </ButtonOutlinedWarningL>
          <BackButton />
        </BottomButtonGroup>
      </Stack>
    </Form>
  )
}

interface InputFormProps {
  categoryMst: GetCategoryMstDto,
  sameAddressFlag: any,
  autoCompleteAddress: any,
  facilitiesTypeList?: {value: string, label: string}[]
}

/** 各項目の入力フォーム */
const InputForm = (props: InputFormProps) => {
  const { categoryMst, sameAddressFlag, autoCompleteAddress } = props
  
  const UserContentAttribute = styled(Grid)({
    padding: '0 0 0 3rem',
  })

  const render = () => {
    switch(categoryMst.category) {
      case "childrenAddress":
        return (
              <div>
                <UserContentAttribute container rowSpacing={3}>
                  <Grid item xs={12} container>
                    <Grid item xs={12}>
                      <CheckBox
                        name="sameAddressFlag"
                        label={''}
                        valueAtCheck={'1'}
                      >
                        保護者と同じ
                      </CheckBox>
                    </Grid>
                  </Grid>
              {/* sameAddressFlag が false の場合のみ表示 */}
              {!sameAddressFlag && (
               <>
                  <Grid item xs={12} container>
                    <Grid item xs={12}>
                      {translate('memberModifyUser.label.postalCode')}
                    </Grid>
                    <Grid item xs={12}>
                      <FlexboxRowTop>
                        <TextBox
                          name="postalCode"
                          label={translate('memberModifyUser.label.postalCode')}
                          textType="postalCode"
                          maxLength={8}
                        />
                        <Separator />
                        <ButtonOutlinedS onClick={autoCompleteAddress}>
                          {translate('memberModifyUser.button.autoComplete')}
                        </ButtonOutlinedS>
                      </FlexboxRowTop>
                    </Grid>
                  </Grid>

                 <Grid item xs={12} container>
                    <Grid item xs={12}>
                      {translate('memberModifyUser.label.prefecturesAndMunicipalities')}
                    </Grid>
                    <Grid item xs={12}>
                      <TextBox
                        name="address1"
                        label={translate('memberModifyUser.label.prefecturesAndMunicipalities')}
                        maxLength={100}
                      />
                    </Grid>
                  </Grid>

                  <Grid item xs={12} container>
                    <Grid item xs={12}>
                      {translate('memberModifyUser.label.address')}
                    </Grid>
                    <Grid item xs={12}>
                      <TextBox
                        name="address2"
                        label={translate('memberModifyUser.label.address')}
                        maxLength={100}
                      />
                    </Grid>
                  </Grid>

                  <Grid item xs={12} container>
                    <Grid item xs={12}>
                      {translate('memberModifyUser.label.buildingNameRoomNumber')}
                    </Grid>
                    <Grid item xs={12}>
                      <TextBox
                        name="buildingNameRoomNumber"
                        label={translate('memberModifyUser.label.buildingNameRoomNumber')}
                        maxLength={100}
                      />
                    </Grid>
                  </Grid>
                  
                  <Grid item xs={12} container>
                    <Grid item xs={12}>
                      {translate('memberModifyUser.label.tel')}
                    </Grid>
                    <Grid item xs={12}>
                      <TelTextBox
                        name={`tel`}
                        label={translate('memberModifyUser.label.tel')}
                      />
                    </Grid>
                  </Grid>
                  </>
              )}
                </UserContentAttribute>
              </div>
        )
      default:
        return null
    }
  }
  return (render())
}

